export const timestampFormat = 'yyyy-MM-dd\'T\'HH:mm:ss.SSS';
export const timestampFormatShort = 'yyyy-MM-dd\'T\'HH:mm:ss';
export const utcTimestampFormatShort = 'yyyy-MM-dd\'T\'HH:mm:ss\'Z\'';
export const timestampFormatWithTimeZone = 'yyyy-MM-dd\'T\'HH:mm:ss.SSSXXXX';
export const utcTimestampFormat = 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'';
export const exportDateTimeFormat = 'yyyy-MM-dd HH:mm:ss';
export const dateFormat = 'dd/MM/yyyy';
export const dateTimeFormat = 'dd/MM/yyyy HH:mm';
export const shortDateTimeFormat = 'dd/MM/yy HH:mm';
export const timeFormat = 'HH:mm';
